import { z } from "zod";
import { MemberErrors, ValidationError } from "@/enums/errorMessages";

// Login Schema
export const loginSchema = z.object({
  username: z
    .string()
    .regex(
      /^[a-zA-Z][a-zA-Z0-9]{3,}$/, //this regex makes sure the username starts with a letter and have min 3 letters
      ValidationError.USERNAME_PATTERN,
    )
    .max(16, ValidationError.USERNAME_MAX),
  password: z
    .string()
    .regex(
      /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/, // this regex makes sure the password contains at least one uppercase , one lowercase , one number and one special character with min 8 letters
      ValidationError.PASSWORD_PATTERN,
    )
    .max(25, ValidationError.PASSWORD_MAX),
});

export const forgotPasswordSchema = z.object({
  email: z.string().email(ValidationError.INVALID_EMAIL),
});
// Signup Schema (Extends Login)
export const signupSchema = loginSchema
  .merge(
    z.object({
      firstName: z.string(),
      lastName: z.string(),
      email: z.string().email(ValidationError.INVALID_EMAIL),
      confirmPassword: z.string(),
    }),
  )
  .refine((data) => data.password === data.confirmPassword, {
    message: ValidationError.PASSWORD_MISMATCH,
    path: ["confirmPassword"],
  });

export const changePasswordSchema = z
  .object({
    newPassword: z
      .string()
      .regex(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/,
        // this regex makes sure the password contains at least one uppercase , one lowercase , one number and one special character with min 8 letters
        ValidationError.PASSWORD_PATTERN,
      )
      .max(25, ValidationError.PASSWORD_MAX),
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ["confirmPassword"],
    message: ValidationError.PASSWORD_MISMATCH,
  });

export const expenseSchema = z.object({
  id: z.number(),
  date: z.string(),
  category: z.number().min(1, "At least one category is required"),
  items: z.array(z.number()),
  amount: z.number().positive("Amount must be positive"),
  reimbursed: z.boolean(),
  reimbursedTo: z.string(),
  billPhotos: z.array(
    z.union([
      z.instanceof(File),
      z.object({
        id: z.number(),
        url: z.string().optional(),
      }),
    ]),
  ),
  description: z.string(),
  branch: z.number().min(1, "At least one branch is required"),
  paymentMethod: z.string().min(1, "At least one payment method is required"),
});

export const categorySchema = z.object({
  name: z.string(),
  organization: z.number(),
});
export const branchSchema = z.object({
  branchName: z.string(),
});
export const itemSchema = z.object({
  name: z.string(),
  organization: z.number(),
});

export const organizationSchema = z.object({
  organizationName: z.string().min(6, {
    message: "Organization name  must be at least 6 characters.",
  }),
});

export const memberSchema = z.object({
  email: z.string().email(ValidationError.INVALID_EMAIL),
  role: z.string().min(1, MemberErrors.ROLE_REQUIRED),
  organization: z.number().min(1, MemberErrors.ORGANIZATION_ID_REQUIRED),
  branch: z.number().nullable(),
});
export const changePasswordschema = z
  .object({
    currentPassword: z
      .string()
      .regex(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/,
        ValidationError.PASSWORD_PATTERN,
      )
      .max(25, ValidationError.PASSWORD_MAX),

    newPassword: z
      .string()
      .regex(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{8,}$/,
        ValidationError.PASSWORD_PATTERN,
      )
      .max(25, ValidationError.PASSWORD_MAX),

    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: ValidationError.PASSWORD_MISMATCH,
    path: ["confirmPassword"],
  });

export const updateMemberSchema = memberSchema.merge(
  z.object({
    username: z.string(),
  }),
);
